import { EARNINGS_FULL_PATH } from "@src/appV2/redesign/Payments/Earnings/paths";
import { WORKER_REFERRALS_PATH_FULL } from "@src/appV2/Referral/path";

/**
 * Maps cbh.care deep links that existed before we migrated to Branch, to the previous route that Firebase Dynamic Links routed to.
 *
 * This is used to redirect users to the correct route when they open the app from a deep link.
 */
export const cbhCarePathMap: Record<string, string | undefined> = {
  "/1gLjU": "/home-v2/shift-discovery/list/shift/68389823fb301cf92c9932a0",
  "/1zCeG": "/home/openShifts/2025-03-11",
  "/1zL4U": "/home-v2/shift-discovery/list/shift/681281f85ec7338db422d11b",
  "/24AxA": "/home-v2/shift-discovery/list/priority/shift/682b61e64c1660b5c0105867",
  "/33nnH": "/home-v2/shift-discovery/list/shift/68083621266180e416624653",
  "/3TwEU": "/home-v2/shift-discovery/list/shift/68092e43177208214e37117b",
  "/3crVc": "/home-v2/shift-discovery/list/shift/6802a6a9f086037b41920b62",
  "/4dD8A": "/home/openShifts/2025-04-16",
  "/5o3P2": "/home-v2/placements/67b5ff19b1ffba88ae739281",
  "/6E2fV": "/home-v2/shift-discovery/list/shift/681e55cd0992686e04a9fd82",
  "/6Jgc1": "/home-v2/shift-discovery/list/shift/68223b2e52647db0fe5df896",
  "/6Q3kX": "/home-v2/shift-discovery/list/shift/681e4caae8ee5b63842500b6",
  "/6TJFN": "/home-v2/shift-discovery/list/shift/681e60ec4af1771965cf0f99",
  "/6gc4q": "/home-v2/shift-discovery/list/shift/685afd6f3ddbb45104508a94",
  "/6kaN9": "/home-v2/shift-discovery/list/shift/67ed677f5b55bacfa3c4046e",
  "/6y4WC": "/home-v2/shift-discovery/list/shift/682839bdf6dc17d450ed9377",
  "/75if9": "/home-v2/shift-discovery/list/shift/68519b0e59e80e5fa05c57c5",
  "/7kEiL": "/home/openShifts/2025-03-13",
  "/7yT4M": "/home-v2/shift-discovery/list/shift/6818f852dfe738a33ff15b4c",
  "/85Xii": "/home-v2/shift-discovery/list/shift/6840b21711c6e46b1a18dfbe",
  "/8Adwo": "/home-v2/shift-discovery/list/shift/680902f8599aea751faf843a",
  "/8XHoF": "/home-v2/shift-discovery/list/shift/681d2b8a2bdff99c01b9abca",
  "/9nczH": "/home-v2/shift-discovery/list/shift/68472b341c070f43c82436ef",
  "/9tgED": "/home-v2/shift-discovery/list",
  "/ADF6e": "/home-v2/shift-discovery/list/shift/68373f2f628a4d43996aa271",
  "/BFBBt": "/home-v2/shift-discovery/list/shift/678837a19b30c2346192ede2",
  "/BPXcp": "/home-v2/shift-discovery/list/shift/681bdeaa6fd274b704f58483",
  "/BiXgG": "/home-v2/shift-discovery/list/shift/67ed519e326917191a771b62",
  "/CBPNZ": "/home-v2/shift-discovery/list/shift/67f411bcc189566798883ef3",
  "/CqVwZ": "/home-v2/shift-discovery/list/shift/67f6edea4c8812e46ca91ff5",
  "/FU2NR": "/home-v2/shift-discovery/list/shift/67eac918d53eb832f50beecf",
  "/GB2eS": "/home-v2/shift-discovery/list/shift/67f95c5cffd322ec91ed28d8",
  "/GEGv3": "/home-v2/shift-discovery/list/shift/6818ce092e5879f837a84805",
  "/GHcqD":
    "/home-v2/placements/workplaces/684c2c67149b47666b6ad569/jobs?source=workplace-profile-modal",
  "/HAhYt": "/home-v2/shift-discovery/list/shift/681e5538befe4c247afb6382",
  "/Ha3rz": "/home/openShifts/2025-03-28",
  "/J6URD": "/home-v2/shift-discovery/list/shift/67f7f26801591ceabb24de67",
  "/JUU3n": "/home/openShifts/2025-03-12",
  "/Jiduv": "/home-v2/shift-discovery/list/shift/683888bb51959a0eb6aacb6c",
  "/JkS8K": "/home-v2/shift-discovery/list/shift/67eda071282778f17fa112b4",
  "/LhNTG": "/home-v2/shift-discovery/list/urgent/shift/680ba6e84ae7ac276f49eed0",
  "/M4xmk": "/home-v2/shift-discovery/list/shift/684212583a08ba2906b69cd8",
  "/M8whj": "/home-v2/shift-discovery/list/shift/681e60e8a6ec3aa12505f88a",
  "/MRLpq": "/home-v2/shift-discovery/list/shift/67ec37e659e518fc1fcf4fc8",
  "/MTPy2": "/home-v2/shift-discovery/list/shift/682fbccab9da5caae635d359",
  "/MonroeManorShifts": "/home/facility/66ad1bb8f72b4153e08d1ac8",
  "/N19WT": "/home-v2/shift-discovery/list/shift/683dedf960385b3f242b607e",
  "/N2ar": "/home/openShifts",
  "/NRng":
    "/home/lastMinuteShifts?method=LAST_MINUTE_SHIFTS_NOTIFICATION&messageId=62fd236b30ee3b01a8628962",
  "/NVumP": "/home/openShifts/2025-03-27",
  "/NcZkR": "/home-v2/shift-discovery/list/shift/68092e27aa64b7c2b852742c",
  "/Nzeh":
    "/home/myShifts/undefined?method=INSTANT_PAY_ADJUSTED_UPPER&messageId=6242f86d5eb61c01adbeeb1f",
  "/PVhVL": "/home-v2/accounts/workplace-referrals",
  "/Pj1PL": "/home-v2/shift-discovery/list/shift/6823ad2906fcad63ae522fc7",
  "/PoZRj": "/home-v2/shift-discovery/list/shift/682fab3f9d51a647eceb99a6",
  "/QQ8CJ": "/home-v2/shift-discovery/list/shift/67eab7121312c078aa3116d2",
  "/QjrBy": "/home-v2/shift-discovery/list/shift/67f7175b9aece7ccc5da4c23",
  "/QkoAg": "/home-v2/shift-discovery/list/shift/681bbfe5bda161fa7ec5cc62",
  "/RHNPa": "/home/openShifts/2025-03-25",
  "/RkcsW": "/home-v2/placements/6830f70469f628aed26cb0f4/",
  "/RkfTu": "/home-v2/shift-discovery/list/shift/682259ca3300a3e50931201a",
  "/SRLWe": "/home-v2/myShifts/shiftInvites",
  "/Sr7Kq": "/home-v2/shift-discovery/list/shift/6812515eceb0b9b9be94fa72",
  "/TDctk": "/home-v2/shift-discovery/list/shift/680ba6cf4fd7cbd5bda22617",
  "/TgwNd": "/home-v2/shift-discovery/list/shift/682ca4ff551c8e4be061744b",
  "/TwqBD": "/home-v2/shift-discovery/list/shift/67fd6b8085bf54d49351e816",
  "/Tx8fL": "/home-v2/shift-discovery/list/shift/68092e611d3df75c7b7b4cdf",
  "/UKwP2": "/home-v2/shift-discovery/list/shift/6824b06e308c036228347ffb",
  "/UUXg1":
    "/home/openShifts?actionType=openJobs&apn=health.clipboard.worker&ibi=health.clipboard.worker&isi=1472962791",
  "/UoNRU": "/home-v2/shift-discovery/list/shift/67f04ddb253b31b3b5d3442e",
  "/V9tGc": "/home/openShifts?shiftBookingTab=jobs",
  "/VV9Vi": "/home-v2/shift-discovery/list/shift/67c8bbef46e46fd00c697e7a",
  "/VXwnG": "/home-v2/shift-discovery/list/shift/6806623624a644f1a813adf1",
  "/VZ15H": "/home-v2/placements?placementsMarketingSource=notYetActivated",
  "/W9jys": "/home-v2/shift-discovery/list/shift/6788379e62c0ffa052d6fad7",
  "/WGmQu": "/home-v2/shift-discovery/list/shift/6824ddc24dcd8c7e9b1bdae7",
  "/WY1ah": "/home-v2/placements/67d1d53e34210e5fb708a96e",
  "/X3N8D": "/home-v2/shift-discovery/list/shift/682211a40c9209beec7fd067",
  "/X5RvH": "/home-v2/shift-discovery/list/shift/680802618e3cb5d3549c139c",
  "/XJmHQ": "/home-v2/shift-discovery/list/shift/67fe852cb9093be0f93f9c83",
  "/Y1dK2": "/home/account/licenses",
  "/YBaEn": "/home-v2/shift-discovery/list/shift/685c8f776b570f2f28042611",
  "/YpZHK": "/home/openShifts/2025-03-19",
  "/ZTqy1": "/home-v2/shift-discovery/list/shift/68156817bd8d98debc214113",
  "/a1BN6": "/home/myShifts/68123b0759081e33af966db5?live-activities=true",
  "/a4eF":
    "/home/lastMinuteShifts?method=LAST_MINUTE_SHIFTS_NOTIFICATION&messageId=6289274b33dc9401c61ddf23",
  "/aDcPN": "/home-v2/shift-discovery/list/shift/67f439b854cfad1a8d22959a",
  "/aFU6n": "/home-v2/shift-discovery/list/shift/6824c282913c80220e1a3b00",
  "/aG2Y3": "/home-v2/shift-discovery/list/shift/68408b840497e4bddd1a8c60",
  "/aT3mM": "/home-v2/shift-discovery/list/shift/67feb38ea758353b7cf63deb",
  "/account": "/home/account",
  "/awZ5B": "/home-v2/placements?placementsMarketingSource=notYetSubmittedApplication",
  "/awhdU":
    "/home-v2/shift-discovery/list/shift/6813d12207ed9506bfd7d322?utm_source=test&utm_medium=test",
  "/c2kNy": "/home-v2/shift-discovery/list/shift/685d956c8bcfa735f3062325",
  "/cSRCq": "/home-v2/shift-discovery/list/shift/67ec73344ad0da325ab55c0c",
  "/cSmgn": "/home-v2/shift-discovery/list/shift/68523ce8cfd4656f68b327f1",
  "/cePHZ": "/home-v2/shift-discovery/list/shift/678837ba8d2735c173c96bd7",
  "/chat": "/home-v2/chat",
  "/dQv8K": "/home-v2/shift-discovery/list/shift/67f7041376049bf58e0010c2",
  "/docs": "/home/account/documents",
  "/eCiSC": "/home-v2/shift-discovery/list/shift/6838b192a2d06a4dde95b822",
  "/eLG2v": "/home-v2/shift-discovery/list/shift/68092e34ad9a524fc531ee09",
  "/edmJi": "/home-v2/placements/workplaces/6583175433cd8b1280ac4b6d/jobs",
  "/esfSc": "/home-v2/shift-discovery/list/shift/684730116cd50c0903aeb976",
  "/fGptx": "/home/openShifts/2025-03-24",
  "/fVL3F": "/home-v2/shift-discovery/list/shift/6838a831ad4b853102886c66",
  "/facility-referral-program-may-24-2024-survey":
    "/home-v2/accounts/workplace-referrals?source=facility-affiliate-survey-24052024",
  "/facility-referrals-promo": "/home-v2/accounts/workplace-referrals",
  "/facility-rules-shift-reminder": "/home/facility/5ec3fcff834a140017a4bde4",
  "/fxS1o": "/home-v2/shift-discovery/list/shift/6812a77b1e9a72b4f253ab9f",
  "/g9HcX": "/home-v2/shift-discovery/list/shift/67bce563ef344d1932db7949",
  "/gJizG": WORKER_REFERRALS_PATH_FULL,
  "/gKDTC": "/home-v2/shift-discovery/list/shift/67b68b5cd88c7719e8383af0",
  "/gXGWM": "/home-v2/shift-discovery/list/shift/6809549cf4a252f137d7cddc",
  "/hMD7L": "/home-v2/shift-discovery/list/shift/67ed677b08ac996365734870",
  "/hcp-chat": "/home-v2/chat",
  "/help-center": "/home/account/needhelp",
  "/hiring-jobs": "/home-v2/placements",
  "/hps": "/home/highest-paying-shifts/cities",
  "/iSF9P": "/home-v2/shift-discovery/list/shift/67bce54fef344d1932db71c2",
  "/iUgRt": "/home-v2/shift-discovery/list/shift/6814f44d0c76ce4a0a81f353",
  "/iXvtW": "/home/openShifts?shiftBookingTab=jobs",
  "/ijNPD":
    "/home-v2/accounts/document-details?requirement=646bcd1b73d2ab0007c7fffd&requirementStatus=optional",
  "/iswWA": "/home-v2/placements/workplaces/5e98a01e83221600166105a9/jobs",
  "/iuL6u": "/home/openShifts/2025-03-05",
  "/kFd6N": "/home-v2/shift-discovery/list/shift/67f3fdf29491727ede6bdba3",
  "/kJnefucPZFYPDJMx9": "/home/openShifts",
  "/kc2cP": "/home-v2/shift-discovery/list/shift/684b42950d6c28b2c099be69",
  "/khHpv": "/home-v2/shift-discovery/list/shift/68092e2bc7f983224c8b6a46",
  "/kvGDF": "/home-v2/shift-discovery/list/shift/683a18ade0a40218796a7ca9",
  "/kvmE3": "/home-v2/placements/67d1d50bbb5676eab928868d",
  "/licenses": "/home/account/licenses",
  "/mDAC":
    "/home/urgentShifts?method=NCNS_URGENT_SHIFTS_NOTIFICATION&messageId=6396da545a8f0701b4017d70",
  "/mhDMV": "/home-v2/shift-discovery/list/shift/67ed67a6b1fce567c96b49ea",
  "/mySchedule": "/home/mySchedule",
  "/myShifts": "/home/myShifts",
  "/notification-center": "/home/notification-center",
  "/notification-preference": "/home-v2/account/notification-preference",
  "/ns9cB": "/home-v2/shift-discovery/list/shift/67ed9d1ecbf833f5ef04f578",
  "/nxTDF": "/home-v2/shift-discovery/list/shift/68228071c9ebf2dd32227bc8",
  "/open-jobs": "/home/openShifts?actionType=openJobs",
  "/open-shifts-on-map": "/home/openShifts?actionType=openMapView",
  "/openBlocks": "/home/openShifts?actionType=openBlocks",
  "/openCases": "/home/openShifts?shiftBookingTab=home-health",
  "/openShifts": "/home/openShifts",
  "/ouLLq": "/home-v2/shift-discovery/list/shift/67ebfee912e7f200f2131b0c",
  "/pF24W": "/home-v2/shift-discovery/list/shift/682fc0f002dfb68a64a55268",
  "/pTukW": "/home-v2/shift-discovery/list/shift/681e55a0cba0ed34e5e7e172",
  "/payroll": EARNINGS_FULL_PATH,
  "/personal-id": "/home/account/documentView?requirement=+5b932fcb38aeaa0014c3688f",
  "/pmvj1": "/home-v2/shift-discovery/list/shift/68504e5b4a0278ec95bf62b6",
  "/poRJj": "/home/openShifts/2025-03-07",
  "/promo": "/home/account/hcp-bonuses",
  "/qP7sM":
    "/home-v2/placements/workplaces/684c2defddb20ccfd66c0569/jobs?source=workplace-profile-modal",
  "/qm6tU": "/home-v2/shift-discovery/list/shift/68092e71a279724349f16e6a",
  "/qnjWR":
    "/home-v2/shift-discovery/map/workplace/67bcab7998c76adfe37237f1/open-shifts/shift/67f02ee3e1739af42a7a3308",
  "/r7ETN": "/home-v2/shift-discovery/list/shift/68092e4c135d4184c8e67a74",
  "/ratings-priority-access": "/home/ratings/priority-access",
  "/referWorkplaces": "/home-v2/accounts/workplace-referrals",
  "/references": "/home/account/documentView?requirement=5ca3b7f50648590016b245e2",
  "/referrals": WORKER_REFERRALS_PATH_FULL,
  "/sDcWA": "/home-v2/shift-discovery/list/shift/6822559db75124b61ea6322e",
  "/sK9Dd": "/home-v2/shift-discovery/list",
  "/sKhkk": "/home-v2/shift-discovery/list/shift/68138480a4927ac5a5152e37",
  "/shiftsAtShalomGardensSeniorLiving": "/home/facility/64d119ae4080602a4eb6775a",
  "/sign-new-agreement": "/home/sign-new-agreement",
  "/t3wzd": "/home-v2/availabilities",
  "/tA4BS": "/home-v2/shift-discovery/list/shift/6806b7929d838308a6e07226",
  "/tCrus": "/home/facility/6705930c25126be6c62014dc",
  "/terms-of-service": "/home/account/needhelp/details",
  "/uVZRN": "/home-v2/shift-discovery/list/shift/68532cedb097d29ec50ab4bd",
  "/upd6u": "/home-v2/shift-discovery/list/shift/684af24f6b9836b1d3d0f8a9",
  "/v3NU8": "/home-v2/shift-discovery/list/shift/682cd4fb9408ddd074ccdb92",
  "/vGK8L": "/home-v2/shift-discovery/list/shift/681e5561d9fccbf102b655c1",
  "/vYYA2": "/home-v2/shift-discovery/list/shift/68091acf231a787895716ec5",
  "/vYYPf": "/home-v2/shift-discovery/list/shift/681e60ee52fb442662ee6743",
  "/vi7kJ": "/home-v2/shift-discovery/list/shift/67eaaf7093dab3faad8f036d",
  "/voQ7x": "/home-v2/shift-discovery/list/shift/6806a8630d5c3373f9bd004e",
  "/vwFrN": "/home-v2/shift-discovery/list/shift/67d3176db929f7d798f7c996",
  "/w8hEJ": "/home-v2/shift-discovery/list/shift/68091ac8e7acbe7341b64ac0",
  "/wM4N1": "/home-v2/placements/workplaces/64f210890fa2a0013d1332f8/profile",
  "/wcczn": "/home-v2/shift-discovery/list/shift/67f544656195e2f0520be5e9",
  "/welcome": "/welcome",
  "/worker-referrals": "/home/account/worker-referrals",
  "/wqRtc": "/home-v2/shift-discovery/list/shift/67c8bbd730d72223ab6b425f",
  "/xBJ4X": "/home-v2/shift-discovery/list/shift/6807c20822f8588c16d58b9a",
  "/xPBXY": "/home-v2/shift-discovery/list/shift/6823799957f461bf30d5dc49",
  "/yByWM": "/home-v2/shift-discovery/list/shift/6827942aeaba98b466e0ddc1",
  "/yXzUQ": "/home-v2/shift-discovery/list/shift/6837758c29dc4b98cbde16e4",
  "/yYM7r": "/home-v2/shift-discovery/list/shift/681e55a0cba0ed34e5e7e172",
  "/zZn4G": "/home-v2/accounts/skills-assessment",
  "/zfzVF": "/home-v2/shift-discovery/list/shift/68092e1811854a3742d4c36b",
  "/zriaa": "/home-v2/shift-discovery/list/shift/68191282edd9a418c078db14",
};
